import React from 'react';

const Title = ({ id, title, customClass, propsRef }) => (
    <div ref={propsRef}>        
        <div id={id} className={ customClass || 'title'}>{title}</div>
        <hr />
    </div>
);

export default Title;